export const normalizeDefaultToNull = value => value === 'default' ? null : value;